const SELF = '_self';

export const launchUri = (url) => window.open(url, SELF);



// WEBPACK FOOTER //
// ./src/UriHelper.js